var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomSip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 28.5153C5 30.5004 5.94801 32.4041 7.63549 33.8078C9.32297 35.2114 11.6117 36 13.9981 36H36.4934C38.2487 36.0016 39.949 35.4909 41.2982 34.5569C42.6474 33.6229 43.5599 32.3248 43.8768 30.8888C44.1937 29.4527 43.8948 27.9697 43.0324 26.698C42.1699 25.4264 40.7984 24.4467 39.1569 23.9297C39.5279 23.0519 39.5965 22.1052 39.3549 21.1967C39.1132 20.2882 38.571 19.454 37.7894 18.7883C37.0078 18.1226 36.018 17.6519 34.9318 17.4295C33.8456 17.207 32.7062 17.2417 31.6424 17.5295C30.9544 15.334 29.2661 13.4475 26.9349 12.2694C24.6038 11.0913 21.813 10.7142 19.1535 11.2179C16.4939 11.7217 14.1745 13.0666 12.6864 14.968C11.1982 16.8695 10.6582 19.178 11.1807 21.4049C9.38225 21.8986 7.8168 22.8516 6.70713 24.1282C5.59745 25.4048 5.00007 26.94 5 28.5153Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1205 22.9976C15.1259 22.2026 15.4468 21.4423 16.0127 20.8839C16.5787 20.3255 17.3432 20.0148 18.1383 20.0201L19.5092 20.0293C20.3685 20.0351 21.114 20.6256 21.3173 21.4604L22.3917 25.8873C22.4788 26.2456 22.4582 26.6217 22.3325 26.9683C22.2069 27.315 21.9817 27.6169 21.6852 27.8361L20.3867 28.7967C20.2511 28.8967 20.2212 29.0444 20.2584 29.1476C20.8121 30.685 21.6933 32.0837 22.841 33.2469C23.9887 34.4101 25.3755 35.31 26.9053 35.8842C27.008 35.9229 27.1551 35.8949 27.2579 35.7607L28.2358 34.4752C28.459 34.1817 28.7639 33.9606 29.1122 33.8395C29.4605 33.7185 29.8368 33.703 30.1939 33.7948L34.606 34.9286C35.438 35.143 36.0185 35.8964 36.0127 36.7567L36.0035 38.1266C35.9982 38.9216 35.6773 39.682 35.1113 40.2404C34.5454 40.7988 33.7808 41.1095 32.9858 41.1042L30.7376 41.0891C22.0464 41.0308 15.0472 33.9371 15.1054 25.2459L15.1205 22.9976Z",
    fill: "black",
    stroke: "#F5F5F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomSip);
export default __webpack_public_path__ + "static/media/customSip.5d45856e11b8082b7328070e9c2309ec.svg";
export { ForwardRef as ReactComponent };